import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IFitsTableIdentificationFormMeta {
    identity: FormInputMeta;
    fitID: FormInputMeta;
    logoID: FormInputMeta;
    nextStateIndex: FormInputMeta;

}

const fitsTableIdentificationFormMeta = {} as IFitsTableIdentificationFormMeta;

fitsTableIdentificationFormMeta.identity = {
    name: "identity",
    type: "text",
    label: "Iden.",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

fitsTableIdentificationFormMeta.fitID = {
    name: "fitID",
    type: "text",
    label: "ID Institution Financière",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

fitsTableIdentificationFormMeta.logoID = {
    name: "logoID",
    type: "text",
    label: "Logo ID",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

fitsTableIdentificationFormMeta.nextStateIndex = {
    name: "nextStateIndex",
    type: "select",
    label: "Index Etat Suivant",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

export default fitsTableIdentificationFormMeta;